var React = require('react');

function ExclMark (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11","cy":"-1041.36","r":"8","transform":"matrix(1 0 0-1 0-1030.36)","opacity":".98","fill":"#da4453","key":0}),React.createElement("path",{"d":"m-26.309 18.07c-1.18 0-2.135.968-2.135 2.129v12.82c0 1.176.948 2.129 2.135 2.129 1.183 0 2.135-.968 2.135-2.129v-12.82c0-1.176-.946-2.129-2.135-2.129zm0 21.348c-1.18 0-2.135.954-2.135 2.135 0 1.18.954 2.135 2.135 2.135 1.181 0 2.135-.954 2.135-2.135 0-1.18-.952-2.135-2.135-2.135z","transform":"matrix(.30056 0 0 .30056 18.902 1.728)","fill":"#fff","stroke":"#fff","key":1})]);
}

ExclMark.defaultProps = {"viewBox":"0 0 22 22"};

module.exports = ExclMark;

ExclMark.default = ExclMark;
